import React from 'react';
import { DATA_ATTR_NODE_ID } from '../../../../labelling-v2/hooks/skeleton-template-builder/constants';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
import { CANVAS } from '../../../constants/template-builder';
type CanvasNodePropsT = {
  id: string;
  position: [number, number];
  colors: {
    fill: string;
    hover: string;
  };
  highlighted: boolean;
  onSelect: () => void;
  onHover: (hovered: boolean) => void;
};
export function CanvasNode({
  id,
  position: [cx, cy],
  colors,
  highlighted,
  onSelect,
  onHover
}: CanvasNodePropsT) {
  const ringWidth = highlighted ? CANVAS.NODE_RING_WIDTH_HOVER : CANVAS.NODE_RING_WIDTH;
  const ringRadius = CANVAS.NODE_RADIUS + ringWidth / 2;
  const inverseScaleStyle = {
    transformOrigin: `${cx}px ${cy}px`,
    transform: `scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
  };
  return <g style={inverseScaleStyle}>
      <circle cx={cx} cy={cy} r={ringRadius} fill="none" stroke={colors.hover} strokeWidth={ringWidth} />
      <circle cx={cx} cy={cy} r={CANVAS.NODE_RADIUS} fill={colors.fill} style={{
      cursor: 'pointer',
      pointerEvents: 'auto'
    }} {...{
      [DATA_ATTR_NODE_ID]: id
    }} data-stage-draggable="true" onClick={onSelect} onPointerEnter={() => onHover(true)} onPointerLeave={() => onHover(false)} />
    </g>;
}